module.exports = __webpack_public_path__ + "assets/bdcac53b436aecc6747bdd0a6e0b829a.mp4";